module.exports = __webpack_public_path__ + "img/poster3.dc41ffbf.png";